export const taskError = 'Aggregator/Payer combination not found';

export const taskListHeaders = [
  { header: 'procedureCode', label: 'PROCEDURE CODE' },
  { header: 'taskID', label: 'TASK ID' },
  { header: 'taskName', label: 'TASK NAME' },
];
